import { userConstants } from "../constants/login.constants";

 function businessNotes(state = {}, action) {
    switch (action.type) {
        case userConstants.GETBUSINESSNOTES_REQUEST:
            return {
                loading: true
            };
        case userConstants.GETBUSINESSNOTES_SUCCESS:
            return {
                items: action.businessNotes
            };
        case userConstants.GETBUSINESSNOTES_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default businessNotes;